package com.starparty.app.astro0.events

import com.starparty.app.astro0.SP_Time
import com.starparty.app.astro0.event.SP_TimeEvent
import com.starparty.app.astro0.event.SP_TimeListener

abstract class  SP_Clock {

    val timeListeners = mutableListOf<SP_TimeListener>()

    var startTime: SP_Time? = null

    abstract fun resetStartTime(startSPTime: SP_Time)

    abstract fun start(startSPTime: SP_Time)

    abstract fun pause()

    protected fun tick(deltaT: Double) {

        val event = SP_TimeEvent(startTime!!, deltaT)

        timeListeners.forEach {
                l -> l.timeChanged(event)
        }
    }

    fun addTimeListener(listener: SP_TimeListener){
        timeListeners.add(listener)
    }

}